import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { updateTime } from '../utilities/helper-functions';
import { Instruction } from '../utilities/utility-components';
import { AuthService } from '../services/auth-service';

import recordicon from '../assets/img/icon-record.svg'
import speaker from '../assets/img/home_graphic_respeaker.svg'
import pod from '../assets/img/icon-pod.svg'
import settings from '../assets/img/settings.svg'
import question from '../assets/img/question.svg'
import logouticon from '../assets/img/logout.svg'
import ragicon from '../assets/img/icon-discover.svg'

function Menus(props) {
  return (
    <div className="option-button small-section" onClick={props.onClick? props.onClick : () => props.route(props.path)}>
      <img alt={props.menuName} src={props.menuIcon} className="w-6 h-6" />
      <div>{props.menuName}</div>
    </div>
  )
}

function HomeScreen(props) {
  const timeOfDay = updateTime();
  const navigate = useNavigate();
  const location = useLocation()
  const [me, setMe] = useState(null);

  useEffect(() => {
    fetch('/api/v1/me').then(r => r.ok ? r.json() : null).then(u => {
      setMe(u);
      // Role-scoped accounts must never see the TA main menu. They have
      // their own landing surfaces; redirect them there if they end up
      // here via bookmark / refresh / back button.
      if (u && u.role === 'student') {
        navigate('/student-app', { replace: true });
      } else if (u && u.role === 'study') {
        navigate('/app', { replace: true });
      } else if (u && u.role === 'math') {
        navigate('/math', { replace: true });
      }
    }).catch(() => {});
  }, []);

  const isAdmin = me && (me.role === 'admin' || me.role === 'super');
  const isRoleScoped = me && (me.role === 'student' || me.role === 'study' || me.role === 'math');

  // Don't paint the TA menu for role-scoped accounts even for the brief
  // moment before the redirect fires.
  if (isRoleScoped) {
    return null;
  }

  const navigateToHelp = () => {
    window.open(
      window.location.protocol +
      "//" +
      window.location.hostname +
      "/help/Default.htm"
    );
  }

  const logout = () => {
    const ret = new AuthService().logout();
    ret.then(
      (response) => { return navigate('/login'); },
      (apiError) => { return navigate('/login'); })
  }

  return (
    <div className="main-container items-center overflow-y-auto">
      <div className="flex flex-col wide-section text-center items-center">
        <div className="font-sans mt-8 text-4xl/relaxed font-bold text-[#6466E3]">Good {timeOfDay}!</div>
        <Instruction instructions="Welcome to the Building Literacy in N-person Collaborations (BLINC) Dashboard. You can start gathering
        analytic data by recording a new discussion." />
      </div>
      <img alt="speaker" className="flex w-36.5 h-36.5 mt-13 mb-12.5" src={speaker} />
      <Menus menuIcon={recordicon} menuName="Discussions" route={navigate} path='/sessions' />
      <Menus menuIcon={ragicon} menuName="User Study" route={navigate} path='/app' />
      <Menus menuIcon={ragicon} menuName="Math Dashboard" route={navigate} path='/math' />
      <Menus menuIcon={ragicon} menuName="Agent Chat (V7)" route={navigate} path='/chat-v7' />
      <Menus menuIcon={ragicon} menuName="Agent Baseline" route={navigate} path='/chat-baseline' />
      <Menus menuIcon={ragicon} menuName="Rate Agent Responses" route={navigate} path='/expert-agent-rating' />
      <Menus menuIcon={speaker} menuName="Record Voiceprint" route={navigate} path='/record-voiceprint' />
      {isAdmin && (
        <Menus menuIcon={speaker} menuName="Voiceprint Management" route={navigate} path='/voiceprints' />
      )}
      <Menus menuIcon={pod} menuName="Pods" route={navigate} path='/pods' />
      <Menus menuIcon={settings} menuName="Settings" route={navigate} path='/Settings' />
      <Menus menuIcon={question} menuName="Help" onClick={navigateToHelp} />
      <Menus menuIcon={logouticon} menuName="Sign Out"  onClick={logout} />
    </div >
  )
}

export { HomeScreen }
